"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9091],{

/***/ 18828:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Summary_Summary; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(95602);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-utils/build/esm/currencyFormatter/index.js
var currencyFormatter = __webpack_require__(93837);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Grid/index.js + 2 modules
var Grid = __webpack_require__(8341);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Dialog/index.js + 1 modules
var Dialog = __webpack_require__(66762);
// EXTERNAL MODULE: ../structure/build-esm/index.js + 38 modules
var build_esm = __webpack_require__(78642);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 121 modules
var utils_build_esm = __webpack_require__(82311);
// EXTERNAL MODULE: ../modules/build/esm/components/ecommerce/FinancialServices/FinancialServicesProvider.js
var FinancialServicesProvider = __webpack_require__(95595);
// EXTERNAL MODULE: ../modules/build/esm/components/ecommerce/FinancialServices/utils.js
var utils = __webpack_require__(19114);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var stereo_ui_styles_build_esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Button/index.js + 2 modules
var Button = __webpack_require__(60861);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/FinancialServices/Summary/Summary.styles.js


var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;





var ContinueButton = (0,styled_components_browser_esm["default"])(Button/* default */.Z).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({
    color: 'secondary',
    mt: 3
  }, props);
})(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)([""])));
var GridContainer = (0,styled_components_browser_esm["default"])(Grid/* default */.Z)(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin-top: ", "px;\n  gap: ", "px;\n\n  ", " {\n    grid-template-columns: 2fr 1fr;\n    grid-template-rows: 1fr;\n  }\n"])), (0,stereo_ui_styles_build_esm.themeGet)('space.4'), (0,stereo_ui_styles_build_esm.themeGet)('space.4'), (0,stereo_ui_styles_build_esm.getMediaQuery)('medium'));
var ItemWithPriceContainer = (0,styled_components_browser_esm["default"])(Grid/* default */.Z).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({
    gridTemplateColumns: '2fr 1fr'
  }, props);
})(_templateObject3 || (_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  align-items: baseline;\n"])));
var ModalContent = styled_components_browser_esm["default"].div(_templateObject4 || (_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  line-height: ", ";\n"])), function (props) {
  return (0,stereo_ui_styles_build_esm.themeGet)('lineHeights.display')(props);
});
var PriceText = (0,styled_components_browser_esm["default"])(Text/* default */.Z).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({
    color: 'text.scratched'
  }, props);
})(_templateObject5 || (_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)([""])));
var Subtotal = styled_components_browser_esm["default"].span(_templateObject6 || (_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  font-weight: ", ";\n  font-size: ", "px;\n"])), function (props) {
  return (0,stereo_ui_styles_build_esm.themeGet)('fontWeights.bold')(props);
}, function (props) {
  return (0,stereo_ui_styles_build_esm.themeGet)('fontSizes.5')(props);
});
var SubtotalValue = (0,styled_components_browser_esm["default"])(Text/* default */.Z)(_templateObject7 || (_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n  color: ", ";\n  font-size: ", "px;\n  font-weight: ", ";\n  margin-left: 4px;\n"])), function (props) {
  return (0,stereo_ui_styles_build_esm.getPaletteColor)('primary.base')(props);
}, function (props) {
  return (0,stereo_ui_styles_build_esm.themeGet)('fontSizes.5')(props);
}, function (props) {
  return (0,stereo_ui_styles_build_esm.themeGet)('fontWeights.bold')(props);
});
var TermLink = (0,styled_components_browser_esm["default"])(Text/* default */.Z)(_templateObject8 || (_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n  cursor: pointer;\n  text-decoration: underline;\n  margin-left: 4px;\n"])));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/FinancialServices/Summary/Summary.js















var Summary = function Summary(_ref) {
  var serviceContent = _ref.serviceContent,
    product = _ref.product,
    handleClickContinue = _ref.handleClickContinue;
  var authorizationTermText = serviceContent.authorizationTermText;
  var installment = product.installment,
    productPrice = product.price,
    title = product.title;
  var _ref2 = installment || {},
    paymentMethodDescription = _ref2.paymentMethodDescription,
    installmentsQty = _ref2.quantity;
  var _useFinancialService = (0,FinancialServicesProvider/* useFinancialService */.B)(),
    selectedServices = _useFinancialService.selectedServices;
  var _useState = (0,react.useState)(false),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    isAuthTermModalOpen = _useState2[0],
    setIsAuthTermModalOpen = _useState2[1];
  var hasSelectedServices = Object.values(selectedServices).length > 0;
  var totalServicesDescription = Object.values(selectedServices).reduce(function (acc, selected) {
    acc.push(selected.description);
    return acc;
  }, []);
  var totalServicesPrice = Object.values(selectedServices).reduce(function (acc, selected) {
    return acc + selected.price;
  }, 0);
  var totalAuthorizationTerm = Object.keys(selectedServices).reduce(function (acc, selected) {
    var selectedContent = (0,utils/* getFinancialServicesContent */.$r)({
      id: selected,
      serviceContent: serviceContent
    });
    var _selectedServices$sel = selectedServices[selected].wageCompensation,
      _selectedServices$sel2 = _selectedServices$sel === void 0 ? {} : _selectedServices$sel,
      wageCompensationAmount = _selectedServices$sel2.amount,
      wageCompensationPercentage = _selectedServices$sel2.percentage;
    var parsedChargingTerms = (0,build_esm/* parsePlaceholders */.VD)(selectedContent == null ? void 0 : selectedContent.chargingTerms, {
      wageCompensationAmount: (0,currencyFormatter/* default */.Z)({
        value: wageCompensationAmount
      }),
      wageCompensationPercentage: "".concat(wageCompensationPercentage, "%")
    });
    return "".concat(acc, "<p>&nbsp;</p>").concat(parsedChargingTerms);
  }, authorizationTermText);
  var subtotalBestPrice = Number(productPrice == null ? void 0 : productPrice.bestPrice) + totalServicesPrice;
  var subtotalFullPrice = Number(productPrice == null ? void 0 : productPrice.fullPrice) + totalServicesPrice;
  var _buildFormattedPriceL = (0,utils/* buildFormattedPriceLabels */.Kc)({
      fullPrice: subtotalFullPrice,
      paymentMethodDescription: paymentMethodDescription,
      price: subtotalBestPrice,
      quantity: installmentsQty
    }),
    formattedInstallment = _buildFormattedPriceL.formattedInstallment,
    formattedSubtotal = _buildFormattedPriceL.formattedPrice;
  var formattedPrice = {
    installments: formattedInstallment,
    productPrice: (0,currencyFormatter/* default */.Z)({
      value: productPrice == null ? void 0 : productPrice.bestPrice
    }),
    subtotal: formattedSubtotal,
    totalServicesPrice: (0,currencyFormatter/* default */.Z)({
      value: totalServicesPrice
    })
  };
  var parsedTerms = (0,build_esm/* parsePlaceholders */.VD)(totalAuthorizationTerm, {
    description: (0,utils/* parseDescriptionValue */.zY)(totalServicesDescription),
    totalPrice: formattedPrice.totalServicesPrice
  });
  return react.createElement(Box/* default */.Z, null, react.createElement(Text/* default */.Z, null, "Resumo"), react.createElement(GridContainer, null, react.createElement(Grid/* default */.Z, {
    gap: 3
  }, react.createElement(ItemWithPriceContainer, null, react.createElement(Flex/* default */.Z, null, react.createElement(Text/* default */.Z, {
    "data-testid": "summary-product-title",
    fontWeight: "bold"
  }, (0,utils_build_esm/* textEllipsis */.vS)(title, 30))), react.createElement(PriceText, {
    "data-testid": "summary-product-price"
  }, formattedPrice.productPrice)), Object.values(selectedServices).map(function (service) {
    return react.createElement(ItemWithPriceContainer, {
      "data-testid": "summary-service-item",
      key: "summary-service-".concat(service.description)
    }, react.createElement(Flex/* default */.Z, {
      alignItems: "center",
      gap: 2
    }, react.createElement(esm/* Icon */.JO$, {
      color: "text.scratched",
      name: "Done"
    }), react.createElement(Text/* default */.Z, {
      color: "text.scratched"
    }, service.description)), react.createElement(PriceText, null, (0,currencyFormatter/* default */.Z)({
      value: service.price
    })));
  }), hasSelectedServices && react.createElement(Text/* default */.Z, {
    fontSize: "small"
  }, "Ao clicar em continuar voc\xEA aceita o", react.createElement(TermLink, {
    "data-testid": "summary-auth-link",
    as: "span",
    onClick: function onClick() {
      return setIsAuthTermModalOpen(true);
    }
  }, "Termo de autoriza\xE7\xE3o de cobran\xE7a"))), react.createElement(Grid/* default */.Z, {
    gap: 2,
    justifySelf: "end"
  }, react.createElement(Box/* default */.Z, {
    lineHeight: "display"
  }, react.createElement(Subtotal, null, "Subtotal:"), react.createElement(SubtotalValue, {
    "data-testid": "summary-subtotal",
    as: "span"
  }, "".concat(formattedPrice.subtotal, " no PIX"))), (formattedPrice == null ? void 0 : formattedPrice.installments) && react.createElement(Text/* default */.Z, {
    "data-testid": "summary-installments",
    fontWeight: "bold",
    color: "footer"
  }, "ou em at\xE9 ".concat(formattedPrice == null ? void 0 : formattedPrice.installments)), react.createElement(ContinueButton, {
    "data-testid": "summary-continue-btn",
    onClick: function onClick() {
      return handleClickContinue(selectedServices);
    }
  }, hasSelectedServices ? 'Contratar e continuar' : 'Ir para sacola'))), react.createElement(Dialog/* default */.Z, {
    "data-testid": "summary-auth-term-modal",
    onClickOutside: function onClickOutside() {
      return setIsAuthTermModalOpen(false);
    },
    bg: "background.white",
    position: "center",
    type: "dialog",
    visible: isAuthTermModalOpen,
    showClose: true,
    titleStyle: {
      alignItems: 'center',
      columnGap: 4,
      forwardedAs: Flex/* default */.Z,
      width: 'calc(100% - 32px)'
    }
  }, react.createElement(ModalContent, {
    dangerouslySetInnerHTML: {
      __html: parsedTerms
    },
    "data-testid": "auth-term-content"
  })));
};
 false ? 0 : void 0;
Summary.defaultProps = {
  product: {},
  serviceContent: {
    authorizationTermText: '',
    financialServicesContent: []
  }
};
/* harmony default export */ var Summary_Summary = (Summary);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/FinancialServices/Summary/index.js


/***/ }),

/***/ 48639:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ DEFAULT_DECLINE_MESSAGE; }
/* harmony export */ });
var DEFAULT_DECLINE_MESSAGE = {
  "default": {
    description: 'Não optar pela contratação do serviço'
  }
};

/***/ }),

/***/ 86223:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _FinancialServices__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _FinancialServices__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76449);


/***/ }),

/***/ 19114:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$r": function() { return /* binding */ getFinancialServicesContent; },
/* harmony export */   "Kc": function() { return /* binding */ buildFormattedPriceLabels; },
/* harmony export */   "PE": function() { return /* binding */ parseFinancialServices; },
/* harmony export */   "hH": function() { return /* binding */ buildTitleByDescription; },
/* harmony export */   "zY": function() { return /* binding */ parseDescriptionValue; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7896);
/* harmony import */ var _magalu_stereo_ui_utils_currencyFormatter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93837);


var buildFormattedPriceLabels = function buildFormattedPriceLabels(_ref) {
  var fullPrice = _ref.fullPrice,
    price = _ref.price,
    quantity = _ref.quantity,
    paymentMethodDescription = _ref.paymentMethodDescription;
  var formattedPrice = (0,_magalu_stereo_ui_utils_currencyFormatter__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
    value: price
  });
  var formattedInstallment = (0,_magalu_stereo_ui_utils_currencyFormatter__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
    value: (fullPrice || price) / quantity
  });
  return (price || fullPrice) && quantity ? {
    formattedInstallment: "".concat(quantity, "x de ").concat(formattedInstallment, " ").concat(paymentMethodDescription || ''),
    formattedPrice: formattedPrice
  } : {};
};
var buildTitleByDescription = function buildTitleByDescription(_ref2) {
  var _description$replace;
  var description = _ref2.description,
    removeString = _ref2.removeString;
  return description ? description == null ? void 0 : (_description$replace = description.replace(removeString, '')) == null ? void 0 : _description$replace.trim() : description;
};
var getFinancialServicesContent = function getFinancialServicesContent(_ref3) {
  var id = _ref3.id,
    serviceContent = _ref3.serviceContent;
  var financialServicesContent = serviceContent.financialServicesContent;
  return financialServicesContent == null ? void 0 : financialServicesContent.find(function (_ref4) {
    var code = _ref4.code;
    return code === id;
  });
};
var parseDescriptionValue = function parseDescriptionValue(value) {
  var startSentence = (value == null ? void 0 : value.length) > 1 ? 'dos seguros' : 'do seguro';
  var descriptions = value.join(', ').replace(/, ([^,]*)$/, ' e $1').toLowerCase();
  return "".concat(startSentence, " ").concat(descriptions);
};
var parseFinancialServices = function parseFinancialServices(_ref5) {
  var product = _ref5.product,
    serviceContent = _ref5.serviceContent;
  var _product$financialSer = product.financialServices,
    financialServices = _product$financialSer === void 0 ? [] : _product$financialSer;
  return financialServices == null ? void 0 : financialServices.map(function (_ref6) {
    var id = _ref6.id,
      offers = _ref6.offers;
    var financialServiceContent = getFinancialServicesContent({
      id: id,
      serviceContent: serviceContent
    });
    return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, financialServiceContent, {
      offers: offers
    });
  });
};

/***/ }),

/***/ 58549:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ FloatText_FloatText; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 121 modules
var build_esm = __webpack_require__(82311);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/utils.js
var utils = __webpack_require__(77833);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/FloatText/FloatText.styles.js


var _templateObject;



var Container = (0,styled_components_browser_esm["default"])(Box/* default */.Z).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({}, props);
})(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n  position: fixed;\n  z-index: ", ";\n  border-bottom: 1px solid #eee;\n  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.14), 0px 2px 2px rgba(0, 0, 0, 0.12),\n    0px 1px 3px rgba(0, 0, 0, 0.2);\n  background-color: ", ";\n  padding: 10px;\n  top: 0;\n"])), function (props) {
  return (0,utils/* themeGet */.R)('zIndices.3')(props);
}, function (props) {
  return (0,utils/* getPaletteColor */.ow)('background.white')(props);
});
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/FloatText/FloatText.js









var FloatText = function FloatText(_ref) {
  var staticProps = _ref["static"];
  var text = staticProps.text,
    path = staticProps.path,
    spa = staticProps.spa,
    truncateLength = staticProps.truncateLength,
    icon = staticProps.icon;
  var iconName = icon.name,
    _icon$width = icon.width,
    width = _icon$width === void 0 ? 30 : _icon$width,
    _icon$height = icon.height,
    height = _icon$height === void 0 ? 30 : _icon$height;
  var handleClick = function handleClick() {
    if (path) (0,build_esm/* routePush */.dY)({
      path: path,
      spa: spa
    });
  };
  return react.createElement(Container, null, react.createElement(Flex/* default */.Z, {
    alignItems: "center",
    gap: "20px"
  }, react.createElement(esm/* Icon */.JO$, {
    name: iconName,
    color: "text.light",
    width: width,
    height: height,
    onClick: handleClick
  }), react.createElement(Box/* default */.Z, null, react.createElement(Text/* default */.Z, {
    fontSize: 1,
    as: "p"
  }, truncateLength ? (0,build_esm/* textEllipsis */.vS)(text, truncateLength) : text))));
};
 false ? 0 : void 0;
FloatText.defaultProps = {
  "static": {
    icon: {
      name: 'ArrowBack'
    },
    path: undefined,
    spa: true,
    truncateLength: 50
  }
};
FloatText.ssr = true;
/* harmony default export */ var FloatText_FloatText = ((0,withLayoutProps/* default */.Z)(FloatText));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/FloatText/index.js


/***/ })

}]);